
import React, { useMemo } from 'react'
import { View, Text } from '@react-pdf/renderer'
import { styles } from '../pdf_table/styled'

export default function ReportCommentsPrefecturePDFTable({
    metadata,
    data,
    campus,
    ciclo,
    escuela,
    direccion,
    isNotfirstPage,
    tipoIncidencias
}) {
    const totalIncidents = useMemo(() => {
        const incidents = []
        data.forEach(element => {
            if (!incidents.includes(element.incidencia)) {
                incidents.push(element.incidencia)
            }
        });
        return incidents
    }, [data])
    const Headers = () => {
        return (
            <View style={{ flexDirection: 'row' }}>
                {
                    metadata && (
                        metadata.map((e, i) => (
                            <View key={i} style={{ width: e.width, ...styles.boxHeader, justifyContent: e.align }}>
                                <Text style={styles.cell}>{e.name}</Text>
                            </View>
                        ))
                    )
                }
            </View>
        )
    }

    return (
        <View style={{ marginTop: 15 }} break={isNotfirstPage}>
            <View style={{ flexDirection: 'row', width: '100%', marginTop: 10 }}>
                {ciclo ? (<Text style={{ fontSize: 10, color: '#000000', marginRight: '25px' }}>Ciclo: {ciclo}</Text>) : null}
                {campus ? (<Text style={{ fontSize: 10, color: '#000000', marginRight: '25px' }}>Campus: {campus}</Text>) : null}
                {escuela ? (<Text style={{ fontSize: 10, color: '#000000', marginRight: '25px' }}>Escuela: {escuela}</Text>) : null}
               
            </View>
            <View style={{ flexDirection: 'row', width: '100%', marginTop: 10 }}>
                {direccion ? (<Text style={{ fontSize: 10, color: '#000000', marginRight: '25px' }}>Dirección: {direccion}</Text>) : null}
            </View>
            <View style={{ marginTop: 10, borderLeft: '1px', borderLeftColor: '#828282', borderTop: '1px', borderTopColor: '#828282' }}>
                <Headers />
                {
                    data && (
                        data.map((e, i) => (
                            <View style={{ flexDirection: 'row' }} key={i}>
                                {metadata.map((el, il) => (
                                    <View key={il} style={{ width: el.width, ...styles.boxRow, justifyContent: el.align, borderTop: i === 0 ? "1px" : "0px" }}>
                                        {
                                            el.fn === null ? (
                                                <Text style={{ ...styles.rows }}>{e[el.id]}</Text>
                                            ) :
                                                <Text> {el.fn(e[el.id])}</Text>
                                        }
                                    </View>
                                ))}
                            </View>
                        ))
                    )
                }
            </View>
            <View style={{ flexDirection: 'row', width: '100%', marginTop: 10, justifyContent: "flex-start" }}>
                <Text style={{ fontSize: 10, color: '#000000', marginRight: '25px' }}>Sub Total Por direcciones: {data.length}</Text>
            </View>
        </View>
    )
}